import React, { useEffect, useState, useContext } from "react";
import { Link, useHistory, useNavigate, useLocation } from "react-router-dom";
import { CurrentUserContext } from "../../../App";
import * as AdminApi from "../../../service/adminApi";
import { getDateTimeFormat, resizeColumn } from "../../helpers/helper";
import DataTable from "../../table/Datatable";
import Pagination from "../../pagination/Pagination";
import DialogTailwindConfirm from "../../DialogTailwindConfirm";
import { RedirectCode400 } from "../../RedirectCode400";
import { FaTrashAlt } from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import TableSearchV1 from "../../tableV1/tableSearchV1";
import PageHeaderV2 from "../../pageheaderV2/PageHeaderV2";
import format from "date-fns/format";

export default function Repeated() {
  const navigate = useNavigate();
  const { setIsMessage } = useContext(CurrentUserContext);
  const [selectedData, setSelectedData] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const [loading, setLoading] = useState(false);
  const [userDataList, setUserDataList] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  const [filters, setFilters] = useState({
    lab_id: "",
    testing_no: "",
    id_card: "",
    hn: "",
    "sample_name.prefix": "",
    "sample_name.first_name": "",
    "sample_name.last_name": "",
    testing_date: "",
    receive_date: "",
    category: "",
    collect_date: "",
    customer_name: "",
    "customer_address.address": "",
    "customer_address.sub_district_name": "",
    "customer_address.district_name": "",
    "customer_address.province_name": "",
    "customer_address.post_code": "",
    expr2: "",
    testing_result: "",
    testing_result_type: "",
    testing_method: "",
    report_no: "",
    report_date: "",
    approve_date: "",
    approve_time: "",
    analyst: "",
    approver: "",
  });
  const [sortBy, setSortBy] = useState({ id: "", desc: false });

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    getDataList();
  }, [page, filters, sortBy]);

  const getDataList = async () => {
    setLoading(true);
    const res = await AdminApi.getLabConflict(
      page,
      10,
      filters,
      formatDate(filters.approve_date),
      formatDate(filters.receive_date),
      formatDate(filters.report_date),
      formatDate(filters.collect_date),
      formatDate(filters.testing_date),
      sortBy.id,
      sortBy.id ? (sortBy.desc ? "desc" : "asc") : "",
    );
    setLoading(false);
    if (res) {
      if (res.data.code === 200) {
        setUserDataList(res["data"]["lab_data_list"]);
        setTotal(res.data.amount);
        setMaxPage(Math.ceil(res.data.amount / 10));
      } else if (res.data.code === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res.data.message_th || res.data.message,
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  // ฟังก์ชันเปิด dialog พร้อมบันทึกข้อมูล row ที่ต้องการ
  const openDialog = (rowData) => {
    // console.log(rowData)
    rowData.message =
      "คุณต้องการลบข้อมูล รหัสตัวอย่าง " + rowData.testing_no + " ใช่หรือไม่?";
    setSelectedData(rowData);
    setIsDialogOpen(true);
  };

  //เปิด Dialog
  const handleConfirm = async (confirmed, data) => {
    setIsDialogOpen(false);
    if (confirmed && data) {
      if (data?.lab_id) {
        removeLabConflict(data?.lab_id);
      }
    }
  };

  const removeLabConflict = async (labId) => {
    //setLoading(true);
    let res = await AdminApi.removeLabConflict(labId);
    //setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        getDataList();
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        //setIsMessage({ type: 'warning', data: res["data"]["message_th"] || res["data"]["message"]});
      }
    } else {
      //setIsMessage({type: 'error', data: 'เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่'})
    }
  };

  const formatDate = (date) => {
    if (!date) return "";
    return format(date, "yyyy-MM-dd");
  };

  const formatDateThai = (date) => {
    const monthsThai = [
      "ม.ค.",
      "ก.พ.",
      "มี.ค.",
      "เม.ย.",
      "พ.ค.",
      "มิ.ย.",
      "ก.ค.",
      "ส.ค.",
      "ก.ย.",
      "ต.ค.",
      "พ.ย.",
      "ธ.ค.",
    ];
    const [year, month, day] = date.split("-");
    const formattedDate = `${parseInt(day)} ${
      monthsThai[parseInt(month) - 1]
    } ${year}`;
    return formattedDate;
  };

  const handleSortChange = (id, desc) => {
    setPage(1);
    setSortBy({ id, desc });
  };

  const columns = [
    {
      Header: "No.",
      accessor: "id",
      Filter: "#",
    },
    {
      Header: "ตัวเลือก",
      Cell: ({ row }) => {
        return (
          <FontAwesomeIcon
            icon={faTrashCan}
            color="#FF0000"
            style={{ cursor: "pointer" }}
            onClick={() => {
              openDialog(row.original);
            }}
          />
        );
      },
    },
    {
      Header: "รหัสตัวอย่าง",
      accessor: "testing_no",
      Filter: "text",
    },
    {
      Header: "เลขบัตรประชาชนผู้ป่วย",
      accessor: "id_card",
      Filter: "text",
    },
    {
      Header: "หมายเลข HN",
      accessor: "hn",
      Filter: "text",
    },
    {
      Header: "คำนำหน้า",
      accessor: "sample_name.prefix",
      Filter: "text",
    },
    {
      Header: "ชื่อ",
      accessor: "sample_name.first_name",
      Filter: "text",
    },
    {
      Header: "นามสกุล",
      accessor: "sample_name.last_name",
      Filter: "text",
    },
    // {
    //   Header: "วันที่ตรวจ",
    //   accessor: "testing_date",
    //   Cell: ({ row }) => {
    //     const createdDate = row.original.testing_date;
    //     return createdDate ? formatDateThai(createdDate) : "";
    //   },
    //   Filter: "date",
    // },
    // {
    //   Header: "วันที่รับตัวอย่าง",
    //   accessor: "receive_date",
    //   Cell: ({ row }) => {
    //     const createdDate = row.original.receive_date;
    //     return createdDate ? formatDateThai(createdDate) : "";
    //   },
    //   Filter: "date",
    // },
    {
      Header: "ชนิดของตัวอย่าง",
      accessor: "category",
      Filter: "text",
    },
    // {
    //   Header: "วันที่เก็บตัวอย่าง",
    //   accessor: "collect_date",
    //   Cell: ({ row }) => {
    //     const createdDate = row.original.collect_date;
    //     return createdDate ? formatDateThai(createdDate) : "";
    //   },
    //   Filter: "date",
    // },
    {
      Header: "หน่วยงานที่ส่งตัวอย่าง",
      accessor: "customer_name",
      Filter: "text",
    },
    {
      Header: "ที่อยู่",
      accessor: "customer_address.address",
      Filter: "text",
    },
    {
      Header: "ตำบล",
      accessor: "customer_address.sub_district_name",
      Filter: "text",
    },
    {
      Header: "อำเภอ",
      accessor: "customer_address.district_name",
      Filter: "text",
    },
    {
      Header: "จังหวัด",
      accessor: "customer_address.province_name",
      Filter: "text",
    },
    {
      Header: "รหัสไปรษณีย์",
      accessor: "customer_address.post_code",
      Filter: "text",
    },
    {
      Header: "ชื่อการทดสอบ",
      accessor: "expr2",
      Filter: "text",
    },
    {
      Header: "ผลการทดสอบ",
      accessor: "testing_result",
      Filter: "text",
    },
    {
      Header: "ประเภทผลการทดสอบ",
      accessor: "testing_result_type",
      Filter: "text",
    },
    {
      Header: "วิธีการทดสอบ",
      accessor: "testing_method",
      Filter: "text",
    },
    {
      Header: "เลขที่ใบรายงานผล",
      accessor: "report_no",
      Filter: "text",
    },
    // {
    //   Header: "วันที่รายงานผล",
    //   accessor: "report_date",
    //   Cell: ({ row }) => {
    //     const createdDate = row.original.report_date;
    //     return createdDate ? formatDateThai(createdDate) : "";
    //   },
    //   Filter: "date",
    // },
    // {
    //   Header: "วันที่ยืนยันผล",
    //   accessor: "approve_date",
    //   Cell: ({ row }) => {
    //     const createdDate = row.original.approve_date;
    //     return createdDate ? formatDateThai(createdDate) : "";
    //   },
    //   Filter: "date",
    // },
    // {
    //   Header: "เวลาที่ยืนยันผล",
    //   accessor: "approve_time",
    // },
    {
      Header: "ผู้วิเคราะห์ผล",
      accessor: "analyst",
      Cell: (row) => (
        <div>
          {row.value.prefix}
          {row.value.first_name} {row.value.last_name}{" "}
        </div>
      ),
      Filter: "text",
    },
    {
      Header: "ผู้รับรองผล",
      accessor: "approver",
      Cell: (row) => (
        <div>
          {row.value.prefix}
          {row.value.first_name} {row.value.last_name}{" "}
        </div>
      ),
      Filter: "text",
    },
  ];

  return (
    <>
      <div className="min-w-[767px] overflow-x-auto">
        <div className="mt-[60px]"></div>
        <div>
          <PageHeaderV2 titlename="รายชื่อผู้ที่มีการตรวจซ้ำ" />
          <TableSearchV1
            columns={columns}
            data={userDataList}
            filters={filters}
            setFilters={setFilters}
            loading={loading}
            total={total}
            page={page}
            maxPage={maxPage}
            setPage={setPage}
            sortBy={sortBy}
            onSortChange={handleSortChange}
            noDataComponent={
              <div className="w-full text-left">ไม่พบข้อมูล</div>
            }
          />
        </div>
      </div>
      {/* เปิด DialogTailwindConfirm พร้อมส่งข้อมูล row ที่เลือก */}
      {isDialogOpen && selectedData && (
        <DialogTailwindConfirm
          onConfirm={handleConfirm}
          onCancel={handleConfirm}
          data={selectedData}
        />
      )}
    </>
  );
}
